<template>
  <section class="product-catalog__container">
    <div v-if="isPending" class="ui-loader__wrapper">
      <span class="ui-loader sticky" />
    </div>
    <div class="product-catalog__wrapper">
      <FilterSettings />
      <section class="product-catalog__body">
        <aside class="product-catalog__aside">
          <FilterBar />
          <SidebarSlider :category-slider="categorySlider" />
        </aside>
        <ProductGallery
          v-if="products?.length > 0"
          :products="products"
          :total-items="totalItems"
          :selections-description="selectionsDescription"
        />
        <IncorrectFilterSet v-else />
      </section>
      <div class="slider-footer">
        <ProductCarouselByLabel
          label="promotion"
          :title="_T('@Promotion slider title')"
        />
        <SeenProductCarousel />
      </div>
    </div>
    <SideFilterMenu :is-pending="isPending" />
  </section>
</template>

<script setup>
import FilterSettings from "~/modules/productCatalog/ui/components/filter/FilterSettings.vue";
import FilterBar from "~/modules/productCatalog/ui/components/filter/bar/FilterBar.vue";
import ProductGallery from "~/modules/productCatalog/ui/components/ProductGallery.vue";
import SeenProductCarousel from "~/modules/shared/sliders/productCarousels/SeenProductCarousel.vue";
import IncorrectFilterSet from "~/modules/productCatalog/ui/components/filter/IncorrectFilterSet.vue";
import ProductCarouselByLabel from "~/modules/shared/sliders/productCarousels/ProductCarouselByLabel.vue";
import { useProductStore } from "~/store/productStore";
import SidebarSlider from "~/modules/shared/sliders/sidebarSlider/SidebarSlider.vue";
import SideFilterMenu from "~/modules/productCatalog/ui/components/filter/SideFilterMenu.vue";

const props = defineProps({
  isPending: { type: Boolean, required: true },
  selectionsDescription: { type: [String, undefined], required: false },
  categorySlider: { type: Array, required: true },
});

const productStore = useProductStore();
const { products, totalItems } = storeToRefs(productStore);
</script>

<style lang="scss" scoped>
.product-catalog {
  &__container {
    position: relative;
    @extend %padding-wrp;

    @include bigMobile {
      padding: 0;
    }
  }

  &__wrapper {
    @extend %width-main;

    @include flex-container(column, flex-start, flex-start);
    gap: 16px;

    margin: 0 auto;
    padding-bottom: 16px;
  }

  &__body {
    width: 100%;

    @include flex-container(row, flex-start, flex-start);
    gap: 8px;

    @include bigMobile {
      flex-direction: column;
      padding: 0 16px;
    }
  }

  &__aside {
    max-width: 256px;
    width: 100%;

    @include flex-container(column, flex-start);
    gap: 16px;

    @include bigMobile {
      display: none;
    }
  }
}

.slider-footer {
  @extend %width-main;

  @include flex-container(column, flex-start);
  gap: 24px;

  @include bigMobile {
    padding: 0 16px;
  }
}
</style>
